import { Modal, Box, Typography, Button } from "@mui/material";

const ErrorModal = ({
  title,
  description,
  onRetry,
  retryButtonText = "Try Again",
}) => {
  document.title = title;
  return (
    <Modal
      open={true}
      onClose={null}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
      slotProps={{
        backdrop: {
          sx: {
            height: "100vh",
          },
        },
      }}
    >
      <Box
        sx={{
          color: "#fff",
          display: "flex",
          flexDirection: "column",
          maxWidth: "30rem",
          backgroundColor: "rgba(20, 0, 0, 0.60)",
          backdropFilter: "blur(5px)",
          alignItems: "center",
          padding: "10px",
          margin: "10px",
          borderRadius: "10px",
          border: "1px solid red",
          boxShadow: "0px 0px 12px red",
          gap: 2,
          outline: 0,
        }}
      >
        <Typography variant="h6" component="h2">
          {title}
        </Typography>
        <Typography align="center">{description}</Typography>
        {onRetry && <Button onClick={onRetry}>{retryButtonText}</Button>}
      </Box>
    </Modal>
  );
};

export default ErrorModal;
